import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './Players_new.css'
import { useSelector, useDispatch } from "react-redux";
import DataService from "../../services/tutorial.service";
import { toast } from "react-toastify";
import LoadingOverlay from "react-loading-overlay-ts";
import { playerlistData, teamlistData } from "../../actions/index";
import { auctiondefaultLogo, playerdefaultLogo, pdfbg } from "../../constants/Images";
import { encode } from "base-64";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCrown, 
  faUserPlus, 
  faFileImport, 
  faFileExport, 
  faFilePdf,
  faSort,
  faSortAlphaDown,
  faSortNumericDown,
  faPencilAlt,
  faTrashAlt
} from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { getDatabase, ref, set, push } from "firebase/database";
import { pushWorkHistory } from "../../utils/worklog";
import { BASE_PATH } from "../../constants/Global";
import ExcelExportModal from '../modals/ExcelExportModal';
import PDFExportModal from '../modals/PDFExportModal';
import { BounceLoader } from 'react-spinners';

export default function Players_new() {
  const [isActive, setActive] = useState(false);
  const [players, setPlayers] = useState([]);
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [playerPath, setPlayerPath] = useState('');
  const [categories, setCategories] = useState([]);
  const [teams, setTeams] = useState([]);
  const [teamPath, setTeamPath] = useState('');
  const [rawPlayerData, setRawPlayerData] = useState(null);
  const loginuser = useSelector((state) => state.setUserlog);
  const dispatch = useDispatch();
  const cid = loginuser["cid"];
  const aid = localStorage.getItem("auction_id");
  const [sortField, setSortField] = useState('number'); // 'number' or 'name'
  const history = useHistory();
  const acname = localStorage.getItem("auction_name");
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [showPDFModal, setShowPDFModal] = useState(false);
  const [aucLogo, setAucLogo] = useState('');
  const [aucLogoPath, setAucLogoPath] = useState('');
  const [currentAuction, setCurrentAuction] = useState(null);
  const [playerImagesBase64, setPlayerImagesBase64] = useState({});

  useEffect(() => {
    localStorage.removeItem('isFirstMount');

    setActive(true);
    fetchCategoryData();
    fetchTeamData();
    fetchData();
    fetchAuctionData();
  }, []);

  // Process player data whenever categories, teams, or raw player data changes
  useEffect(() => {
    if (rawPlayerData) {
      processPlayerData();
    }
  }, [categories, teams, rawPlayerData]);

  // Filter players whenever search term, category, or status changes
  useEffect(() => {
    filterPlayers();
  }, [searchTerm, selectedCategory, selectedStatus, players]);

  // Convert a URL to base64
  const convertImageToBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting image to base64:", error);
      return null;
    }
  };

  // Load player images when data is processed
  const loadPlayerImages = async () => {
    if (!rawPlayerData || !rawPlayerData.success) return;
    
    const imagesObj = {};
    const playerList = rawPlayerData.data.list;
    const imagePath = rawPlayerData.data.path || '';
    console.log('playerList')
    console.log(playerList)
    console.log(imagePath)
    
    try {
      setActive(true);
      console.log("Loading player images. Path:", imagePath);
      
      // Process in batches to avoid overwhelming the browser
      const batchSize = 5;
      const totalPlayers = playerList.length;
      
      for (let i = 0; i < totalPlayers; i += batchSize) {
        const batch = playerList.slice(i, i + batchSize);
        
        // Process batch sequentially to avoid too many simultaneous requests
        for (const player of batch) {
          if (player.img && player.img !== '') {
            try {
              const imageUrl = imagePath + player.img;
              console.log(`Converting image for player ${player.pid}: ${imageUrl}`);
              
              const base64 = await convertImageToBase64(imageUrl);
              if (base64) {
                console.log('base64')
                console.log(base64)
                console.log(`Successfully converted image for player ${player.pid}`);
                imagesObj[player.pid] = base64;
              } else {
                console.warn(`Failed to convert image for player ${player.pid}`);
                // Use a default image instead
                imagesObj[player.pid] = playerdefaultLogo;
              }
            } catch (err) {
              console.error(`Error processing image for player ${player.pid}:`, err);
              imagesObj[player.pid] = playerdefaultLogo;
            }
          } else {
            console.log(`No image for player ${player.pid}, using default`);
            imagesObj[player.pid] = playerdefaultLogo;
          }
        }
      }
      
      console.log(`Converted ${Object.keys(imagesObj).length} player images to base64`);
      setPlayerImagesBase64(imagesObj);
    } catch (error) {
      console.error("Error loading player images:", error);
    } finally {
      setActive(false);
    }
  };

  // Handle PDF click with image preloading
  const handlePDFClick = async () => {
    setActive(true);
    // Load player images if not already loaded
    if (Object.keys(playerImagesBase64).length === 0) {
      await loadPlayerImages();
    }
    setShowPDFModal(true);
    setActive(false);
  };

  const filterPlayers = () => {
    let filtered = [...players];

    // Filter by search term
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      if (term.length > 0) {
        if (/^\d+$/.test(term)) { // If search term is a number
          if (term.length >= 6) {
            // Filter by mobile number
            filtered = filtered.filter(player => 
              player.mobile && player.mobile.includes(term)
            );
          } else {
            // Filter by player code
            filtered = filtered.filter(player => 
              player.number.toString().includes(term)
            );
          }
        } else {
          // Filter by player name
          filtered = filtered.filter(player =>
            player.name.toLowerCase().includes(term)
          );
        }
      }
    }

    // Filter by category
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(player => player.category === selectedCategory);
    }

    // Filter by status
    if (selectedStatus !== 'all') {
      switch (selectedStatus) {
        case 'available':
          filtered = filtered.filter(player => !player.sold && !player.frozen && !player.skipped);
          break;
        case 'sold':
          filtered = filtered.filter(player => player.sold && !player.frozen);
          break;
        case 'freezed':
          filtered = filtered.filter(player => player.frozen);
          break;
        case 'unsold':
          filtered = filtered.filter(player => player.skipped);
          break;
        case 'owners':
          filtered = filtered.filter(player => player.owner);
          break;
        default:
          break;
      }
    }

    setFilteredPlayers(filtered);
  };

  const fetchCategoryData = async () => {
    var hdr = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "authorization": JSON.stringify([{ 'cid': cid, 'token': loginuser["token"] }])
      }
    };

    try {
      const res = await DataService.listCategory({ 'aid': aid }, hdr);
      const response = res.data;
      
      if (response.success === true) {
        const categoryList = response.data.list.sort((a, b) => a.catord - b.catord);
        console.log('Category data loaded:', categoryList.length);
        setCategories(categoryList);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchTeamData = async () => {
    var hdr = {
      params: {
        frm: 1,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    try {
      const res = await DataService.listTeam({}, hdr);
      const response = res.data;
      
      if (response.success === true) {
        const responsedata = response.data;
        console.log('Team data loaded:', responsedata.list.length);
        console.log('Team data:', responsedata.list);
        setTeams(responsedata.list);
        setTeamPath(responsedata.path || '');
        
        // Update Redux store
        dispatch(teamlistData({ responsedata }));
      }
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };

  const processPlayerData = () => {
    console.log('processing player data...')          
    if (!rawPlayerData || !rawPlayerData.success) return;
    
    const responsedata = rawPlayerData.data;
    const sortedData = responsedata.list.sort((a, b) => a.pcode - b.pcode);
    responsedata.list = sortedData;
    
    // Transform data to match our component format
    if (responsedata.list && responsedata.list.length > 0) {
      const transformedPlayers = responsedata.list.map(player => {
        // Collect all specifications from spcf1, spcf2, spcf3
        const specs = [];
        if (player.spcf1) specs.push(player.spcf1);
        if (player.spcf2) specs.push(player.spcf2);
        if (player.spcf3) specs.push(player.spcf3);
        
        // Parse and process morefields if available
        if (player.runwkt) {
          try {
            const parsedMore = typeof player.runwkt === 'string' ? JSON.parse(player.runwkt) : player.runwkt;
            // Add morefields to the specs array
            if (parsedMore) {
              Object.entries(parsedMore).forEach(([key, value]) => {
                if (value.V && value.V !== "") {
                  specs.push(`${value.N}: ${value.V}`);
                }
              });
            }
          } catch (error) {
            console.error("Error parsing player morefields:", error);
          }
        }
        
        // Find the category name based on catid
        const playerCategory = categories.find(cat => cat.cid === player.catid);
        const categoryName = playerCategory ? playerCategory.cname : player.pcat || '';
        
        // Find the team name based on tmid if player is assigned to a team
        let teamName = 'Unsold';
        if (player.tmid && parseInt(player.tmid) > 0) {
          const playerTeam = teams.find(team => team.tid === player.tmid);
          teamName = playerTeam ? playerTeam.name : player.tname || 'Unsold';
        }
        
        return {
          id: player.pid,
          number: player.pcode || 0,
          name: player.pname || 'Unknown Player',
          image: player.img ? responsedata.path + player.img : playerdefaultLogo,
          age: player.age || 'N/A',
          category: categoryName,
          specs: specs.length > 0 ? specs : (player.tag ? player.tag.split(',') : []),
          team: teamName,
          teamDisplay: teamName,
          sold: player.tmid > 0,
          points: player.points ? parseInt(player.points) : (player.sold_amt ? parseInt(player.sold_amt) : 0),
          owner: player.isowner !== "0",
          frozen: player.isfreez !== "0",
          skipped: player.isskiped !== "0",
          mobile: player.mobile || ''  // Add mobile number for filtering
        };
      });
      
      setPlayers(transformedPlayers);
      setFilteredPlayers(transformedPlayers);  // Initialize filtered players with all players
      
      // Update Redux store
      dispatch(playerlistData({ responsedata }));
    }
    console.log('its perfecct...')
    
    // Deactivate loading overlay once processing is complete
    setActive(false); 
  };

  const fetchData = async () => {
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencodedf",
        authorization: JSON.stringify([
          { cid, aid, token: loginuser["token"] },
        ]),
      },
    };

    try {
      const res = await DataService.listPlayer({ self: 1 }, hdr);
      const response = res.data;
      
      if (response.success === true) {
        console.log('Player data loaded');
        console.log('Player data:', response.data.list);
        setPlayerPath(response.data.path || '');
        setRawPlayerData(response);
      } else {
        toast.error(response.msg || "Failed to load players", {
          theme: "colored",
          position: "bottom-center",
        });
        setActive(false);
      }
    } catch (error) {
      console.error("Error fetching players:", error);
      toast.error("Server error. Failed to load players", {
        theme: "colored",
        position: "bottom-center",
      });
      setActive(false);
    }
  };

  const fetchAuctionData = async () => {
    setActive(true);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    try {
      const res = await DataService.listAuction({ myauction: 1 }, hdr);
      const response = res.data;
      
      if (response.success === true) {
        const responsedata = response.data;
        const currentAuc = responsedata.list.find(ele => ele.aid === aid);
        
        if (currentAuc) {
          setCurrentAuction(currentAuc);
          setAucLogo(currentAuc.logo);
          setAucLogoPath(responsedata.path);
          console.log('Auction logo data loaded:', currentAuc.logo);
        }
      }
    } catch (error) {
      console.error("Error fetching auction data:", error);
    } finally {
      setActive(false);
    }
  };

  // Add sorting function
  const handleSort = (field) => {
    setSortField(field);
    let sorted = [...filteredPlayers];
    if (field === 'name') {
      sorted.sort((a, b) => a.name.localeCompare(b.name));
    } else {
      sorted.sort((a, b) => a.number - b.number);
    }
    setFilteredPlayers(sorted);
  };

  // Handle Add Player click
  const handleAddPlayer = () => {
    history.push('/add-auction-player');
  };

  // Handle Edit Player click
  const handleEditPlayer = (e, playerId) => {
    e.preventDefault();
    history.push(`/edit-auction-player/${encode(playerId)}`);
  };

  // Handle Delete Player click
  const handleDeletePlayer = async (e, playerId) => {
    e.preventDefault();
    
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        container: 'swal-overlay',
        popup: 'swal-popup',
      },
      allowOutsideClick: false,
      scrollbarPadding: false,
      backdrop: `rgba(0,0,0,0.4)`
    });

    if (result.isConfirmed) {
      try {
        setActive(true);
        const hdr = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization: JSON.stringify([{ cid, aid, token: loginuser["token"] }])
          }
        };

        const res = await DataService.deletePlayer({ pid: encode(playerId) }, hdr);
        const response = res.data;

        if (response.success) {
          // Update Firebase
          const db = getDatabase();
          
          // Update auction info
          await set(ref(db, 'map/info/' + aid), {
            "type": "4",
            "upd": "3",
            'id': playerId,
            "detail": "",
            "tkn": loginuser["token"]
          });

          // Add to work history
          const workhistory = {
            worktyp: 'work11',
            timestamp: new Date().toISOString(),
            aname: acname,
            aid: aid
          };
          await pushWorkHistory(workhistory);

          // Show success message
          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });
          

          // Update local state
          const updatedPlayers = players.filter(p => p.id !== playerId);
          setPlayers(updatedPlayers);
          setFilteredPlayers(updatedPlayers);

          // Refresh data
          fetchData();
        } else {
          await Swal.fire({
            title: 'Error!',
            text: response.msg || 'Failed to delete player',
            icon: 'error',
            customClass: {
              container: 'swal-overlay',
              popup: 'swal-popup',
            },
            scrollbarPadding: false
          });
        }
      } catch (error) {
        console.error('Error deleting player:', error);
        await Swal.fire({
          title: 'Error!',
          text: 'Failed to delete player',
          icon: 'error',
          customClass: {
            container: 'swal-overlay',
            popup: 'swal-popup',
          },
          scrollbarPadding: false
        });
      } finally {
        setActive(false);
      }
    }
  };

  // Add import handler function
  const handleImport = () => {
    history.push(BASE_PATH + 'import-players');
  };

  // Handle Excel click
  const handleExcelClick = () => {
    setShowExcelModal(true);
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .swal-overlay {
        position: fixed;
        padding: 0 !important;
        width: 100%;
        height: 100%;
        z-index: 9999;
      }
      .swal-popup {
        padding: 0 !important;
      }
      .swal2-container {
        position: fixed !important;
        padding: 0 !important;
      }
      .swal2-backdrop-show {
        padding: 0 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <LoadingOverlay
      active={isActive}
      spinner={<BounceLoader color={"#337ab7"} />}
    >
      <div className="players-new-container">
        <div className="players-header">
          <div className="header-primary">
            <div className="header-left">
              <h1 className="page-heading">PLAYERS</h1>
              <div className="sort-toggle">
                <button 
                  className={`sort-button ${sortField === 'number' ? 'active' : ''}`}
                  onClick={() => handleSort('number')}
                  title="Sort by Number"
                >
                  <FontAwesomeIcon icon={faSortNumericDown} />
                </button>
                <button 
                  className={`sort-button ${sortField === 'name' ? 'active' : ''}`}
                  onClick={() => handleSort('name')}
                  title="Sort by Name"
                >
                  <FontAwesomeIcon icon={faSortAlphaDown} />
                </button>
              </div>
            </div>

            <div className="action-buttons">
              <button className="action-button secondary" onClick={handleImport}>
                <FontAwesomeIcon icon={faFileImport} />
                Import
              </button>
              <button className="action-button secondary" onClick={handleExcelClick}>
                <FontAwesomeIcon icon={faFileExport} />
                Excel
              </button>
              <button className="action-button secondary" onClick={handlePDFClick}>
                <FontAwesomeIcon icon={faFilePdf} />
                PDF
              </button>
              <button className="action-button primary" onClick={handleAddPlayer}>
                <FontAwesomeIcon icon={faUserPlus} />
                Add
              </button>
            </div>
          </div>

          <div className="header-secondary">
            <div className="filter-controls">
              <input
                type="text"
                className="filter-input"
                placeholder="Search by name, mobile or player code..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              
              <select 
                className="filter-select"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <option value="all">All Categories</option>
                {categories.map(category => (
                  <option key={category.cid} value={category.cname}>
                    {category.cname}
                  </option>
                ))}
              </select>

              <select 
                className="filter-select"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="all">All Status</option>
                <option value="available">Available</option>
                <option value="sold">Sold</option>
                <option value="freezed">Freezed</option>
                <option value="unsold">Unsold</option>
                <option value="owners">Owners</option>
              </select>
            </div>
          </div>
        </div>

        {filteredPlayers.length > 0 ? (
          <div className="player-list">
            {filteredPlayers.map(player => (
              <Link to={`/player/${player.id}`} key={player.id} className={`compact-player-card ${
                player.skipped ? 'unsold-player-card' :
                player.frozen ? 'frozen-player-card' : 
                player.sold ? 'sold-player-card' : 
                'available-player-card'
              }`}>
                <div className="player-number">{player.number}</div>
                <div className="player-avatar">
                  <img src={player.image} alt={player.name} onError={(e) => {e.target.onerror = null; e.target.src = auctiondefaultLogo}} />
                  {player.sold && (
                    <div className="points-banner">
                      {player.points.toLocaleString()}
                    </div>
                  )}
                  {player.owner && (
                    <svg className="owner-crown-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#FFD700">
                      <path d="M12 1L9 9 2 6l2 15h16l2-15-7 3-3-8z"/>
                    </svg>
                  )}
                </div>
                
                <div className="player-content">
                  <div className="card-top-bar"></div>
                  <div className="player-header">
                    <h3 className="player-name">{player.name}</h3>
                    {player.sold && <div className={`sold-stamp ${player.frozen ? 'frozen-color' : ''}`}>{player.frozen ? 'Retained' : 'SOLD'}</div>}
                    {player.skipped && <div className="sold-stamp unsold-color">UNSOLD</div>}
                  </div>
                  
                  <div className="player-details">
                    <div className="player-info">
                      <span className="player-age">{player.age} yrs</span>
                      <span className="player-category">
                        {player.category}
                      </span>
                    </div>
                    
                    {player.specs && player.specs.length > 0 && (
                      <div className="player-tags-wrapper">
                        <div className="player-tags">
                          {player.specs.map((spec, index) => (
                            <div key={index} className="tag">{spec}</div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  
                  {player.sold && (
                    <div className="player-team-banner">
                      <span>{player.teamDisplay}</span>
                    </div>
                  )}
                  <div className="card-actions">
                    <button 
                      className="card-action-btn" 
                      title="Edit Player"
                      onClick={(e) => handleEditPlayer(e, player.id)}
                    >
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </button>
                    <button 
                      className="card-action-btn" 
                      title="Delete Player"
                      onClick={(e) => handleDeletePlayer(e, player.id)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="no-results-message">
            {isActive ? "Loading Players..." : "No players found matching your filters"}
          </div>
        )}
    </div>

      {/* Add the Excel modal */}
      <ExcelExportModal 
        isOpen={showExcelModal}
        onClose={() => setShowExcelModal(false)}
        data={rawPlayerData}
        categories={categories}
        teams={teams}
        currentAuction={{
          aid: aid,
          name: acname
        }}
      />

      {/* Add the PDF modal */}
      <PDFExportModal 
        isOpen={showPDFModal}
        onClose={() => setShowPDFModal(false)}
        data={rawPlayerData}
        categories={categories}
        teams={teams}
        currentAuction={{
          aid: aid,
          name: acname
        }}
        backgroundImage={pdfbg}
        auctionLogo={aucLogo && aucLogoPath ? `${aucLogoPath}${aucLogo}` : auctiondefaultLogo}
        playerImages={playerImagesBase64}
      />
    </LoadingOverlay>
  )
}
